import * as NavConst from '../components/constants/NavigationConstants';
import * as SweetAlert from '../components/common/utilities/ConfirmationAlert';
import { GENERIC_PAGINATED_KEY_VALUE_LIST, getApiPath, DELETE, USER, LIST, DASHBOARD_USERS } from '../api/ApiConst';
import apiCaller from "../api/ApiCaller";

export const DahsboardUsers = {
  basePath: "dashboard-users",
  tableDataUrl:LIST,
  label: "Users for Dashboard",
  attributes: [{ name: "id", value: "id", type: "text", position: 0, formAttribute: false },
  { name: "dashboardId", value: "dashboardId", type: "text", position: 1, formAttribute: false },
  {
    name: "User", value: "userId", type: "select", position: 2, formAttribute: true, isStatic: false, basePath: "user",
    dataListFunction: () => {
      const options = []
      var jsonRequest = { "page": 0, "size": 200, searchFilters: [], sortRules: [] };
      apiCaller.callPostApi(getApiPath(USER, GENERIC_PAGINATED_KEY_VALUE_LIST), jsonRequest, {}, (response) => {
        response.data.map((d) => {
          options.push({ value: d.key, label: d.value })
        });
      }, (error) => {
        console.error(error);
      });
      return options
    }
  }
  ],
  actions: [
    { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
    {
      name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
      navigatePath: getApiPath(DASHBOARD_USERS, DELETE), replaceData: "{recordId}"
    },
    { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
    { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
  ]
};



